import React from "react";
import classes from "./TitleContainer.module.css";

const TitleContainer = (props) => (
  <div className={classes.titleContainer}>{props.children}</div>
);

export default TitleContainer;
